import React from 'react';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import _map from 'lodash/map';

import { InputRenderer } from '../renderer';
import { FilterConfigT } from './types';

interface KeyValueFilterProps {
	filterConfig: FilterConfigT;
	onSubmit: (data: any) => void;
}

const KeyValueFilter = ({ filterConfig, onSubmit }: KeyValueFilterProps) => {
	const { componentsRenderConfig, filterDefaults, validationSchema } = filterConfig;
	const {
		watch,
		control,
		handleSubmit,
		formState: { errors }
	} = useForm({
		defaultValues: filterDefaults,
		resolver: yupResolver(validationSchema || yup.object(), { initialValues: filterDefaults })
	});

	const [css] = useStyletron();

	return (
		<form className={css({ display: 'flex', gap: '20px' })} onSubmit={handleSubmit(onSubmit)}>
			{_map(componentsRenderConfig, (field) => (
				<InputRenderer errors={errors} field={field} control={control} watch={watch} />
			))}
			<Button kind='primary'>Filter</Button>
		</form>
	);
};

export default KeyValueFilter;
